import { render, staticRenderFns } from "./ManagePurchaseProductNames.vue?vue&type=template&id=66a96aba&"
import script from "./ManagePurchaseProductNames.vue?vue&type=script&lang=js&"
export * from "./ManagePurchaseProductNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports